'use client'

import '@/views/operations/customer-service/GoldPrice.css'

import { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'

import api from '@/utils/api'

import '@/styles/page.css'

import { isEmpty } from 'lodash'

import { convertDateFormat } from '@/utils'

const ForeignExchangeRates = ({ initialData }) => {
  const [currencyData, setCurrencyData] = useState(initialData ?? {})

  const fetchForexRates = async () => {
    try {
      const response = await api.get('/foreign-exchange-rates', { params: { populate: '*' } })
      setCurrencyData(response.data.data[0])
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }

  // DELIBERATE CLIENT REFETCH (decided 2026-08-17) — do not remove.
  // initialData (build-time snapshot) paints instantly and is what crawlers index,
  // but a Strapi publish takes 3-15 min to reach prod via deploy-prod-on-publish.
  // Displaying a superseded FX rate for that long is unacceptable, so this page
  // revalidates on mount. Excluded from tests/no-client-cms-fetch.spec.ts.
  // See docs/superpowers/plans/2026-08-17-remove-client-side-cms-refetch.md Task 5.
  useEffect(() => {
    fetchForexRates()
  }, [])

  return (
    <div className="container page">
      <h1 className="page-title">Exchange Rates</h1>

      <Table
        responsive="xs"
        bordered
        style={{
          color: '#070070',
          border: 'none'
        }}
      >
        <thead>
          <tr className="table-title">
            <th colSpan={7}>
              As of {!isEmpty(currencyData) && convertDateFormat(currencyData?.date)}
            </th>
          </tr>
          <tr className="table-head">
            <th colSpan={2} style={{ textAlign: 'start' }}>
              Currency
            </th>
            <th colSpan={1}>Selling</th>
            <th colSpan={2}>Buying</th>
            <th colSpan={2}>Currency Notes</th>
          </tr>
          <tr className="table-subhead">
            <th></th>
            <th></th>
            <th>TT/OD</th>
            <th>TT</th>
            <th>OD</th>
            <th>Selling</th>
            <th>Buying</th>
          </tr>
        </thead>
        <tbody>
          {!isEmpty(currencyData) &&
            currencyData?.currencies?.map((currency, index) => {
              const formattedSellingTTOD =
                !isNaN(currency.sellingTTOD) && !isNaN(Number.parseFloat(currency.sellingTTOD))
                  ? Number.parseFloat(currency.sellingTTOD).toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 5
                    })
                  : 'N/A'
              const formattedBuyingTT =
                !isNaN(currency.buyingTT) && !isNaN(Number.parseFloat(currency.buyingTT))
                  ? Number.parseFloat(currency.buyingTT).toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 5
                    })
                  : 'N/A'
              const formattedBuyingOD =
                !isNaN(currency.buyingOD) && !isNaN(Number.parseFloat(currency.buyingOD))
                  ? Number.parseFloat(currency.buyingOD).toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 5
                    })
                  : 'N/A'
              const formattedCurrencyNotesSelling =
                !isNaN(currency.currencyNotesSelling) &&
                !isNaN(Number.parseFloat(currency.currencyNotesSelling))
                  ? Number.parseFloat(currency.currencyNotesSelling).toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 5
                    })
                  : 'N/A'
              const formattedCurrencyNotesBuying =
                !isNaN(currency.currencyNotesBuying) &&
                !isNaN(Number.parseFloat(currency.currencyNotesBuying))
                  ? Number.parseFloat(currency.currencyNotesBuying).toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 5
                    })
                  : 'N/A'
              return (
                <tr className="table-data" key={index}>
                  {/* Currency Name */}
                  <td>{`${currency.denomination} ${currency.currency}`}</td>
                  <td style={{ textAlign: 'center' }}>{currency.abbreviation || 'N/A'}</td>
                  {/* Currency Code */}
                  <td style={{ textAlign: 'center' }}>{formattedSellingTTOD}</td>
                  {/* TT/OD */}
                  <td style={{ textAlign: 'center' }}>{formattedBuyingTT}</td>
                  {/* TT */}
                  <td style={{ textAlign: 'center' }}>{formattedBuyingOD}</td>
                  {/* OD */}
                  <td style={{ textAlign: 'center' }}>{formattedCurrencyNotesSelling}</td>
                  {/* Selling */}
                  <td style={{ textAlign: 'center' }}>{formattedCurrencyNotesBuying}</td>
                  {/* Buying */}
                </tr>
              )
            })}
        </tbody>
      </Table>
      <div className="pt-4" style={{ color: '#72788E' }}>
        <p>
          <br />
          <b>Note:</b> Exchange rates may change without prior notice. Please contact our branches
          or our 24-Hour Customer Care Consultants for the latest rates.
        </p>
      </div>
    </div>
  )
}

export default ForeignExchangeRates
